
import { Component, Vue, Watch } from "vue-property-decorator";
import CollapseItem from "@/components/collapse.vue";
import PageFooter from "@/components/page-footer.vue";
import { imgHost } from "@/utils/config";
import { memberAuthInfoByPhone, addmember } from "@/api/agent_user";
import UploadImg from "@/components/upload-img.vue";

@Component({
	name: "add-member",
	components: {
		CollapseItem,
		PageFooter,
		UploadImg,
	},
})
export default class AddMember extends Vue {
	private id = +this.$route.query.id || 0;
	private imgUrl = imgHost;
	private gradeList = [
		{
			label: "VIP",
			value: 3,
			disabled: false,
		},
		{
			label: "VIC",
			value: 2,
			disabled: false,
		},
		{
			label: "SVIC",
			value: 1,
			disabled: false,
		},
	];
	
	private formData: any = {
		"Name": "",
		"Phone": "",
		"Password": "",
		"RoleGrade": "",
		"RecommendId": "",
		"WeixinId": "",
		"IdCardNo": "",
		"CardIdFrontImgUrl": "",
		"CardIdBackImgUrl": ""
	};

	private loading = false;
	private recommendList:any = [];
	private btnLoading = false;

	private mounted() {
		// if (this.id) {
		// 	this.getDetail();
		// }
	}

	private toBack() {
		this.$router.go(-1);
	}


	/**
	 * 监听输入框
	 */
	private handleInput(type: string) {
		console.log(type);
	}

	private valid(){
		let toast = '';
		if (!this.formData.Name){
			toast = '请输入姓名';
		}else if (!this.formData.Phone){
			toast = '请输入手机号';
		}else if (!this.formData.Password){
			toast = '请设置登录密码';
		}else if (!this.formData.RoleGrade){
			toast = '请选择注册序列';
		}

		if (toast){
			this.$message.error(toast);
			return false
		}

		return true;
	}

	// 提交信息
	private async submit() {
		if (!this.valid()) return;

		this.btnLoading = true;
		try {
			const res = await addmember(this.formData);

			this.$message.success('添加成功');
			this.$router.back();
		} catch (error) {
			
		} finally{
			this.btnLoading = false;
		}
	}

	// 上传成功
	private uploadSuc(list: any, type?: string) {
		this.formData[type] = list[0];
	}

	private isPhone(tel) {
		var reg = /^1[3-9]\d{9}$/;
		return reg.test(tel);
	}

	/**
	 * 获取分销员列表 
	 */
	private async remoteMethod(query?: string) {
		console.log(query)
		if (!query.length) return;
		query = query.trim();
		this.loading = true;
		let params: any = {
			Phone: query
		};
		try {
			const res: any = await memberAuthInfoByPhone(params);
			this.recommendList = [res.Result];
			this.loading = false;
		} catch (e) {
			this.loading = false;
		}
	}
}
